<template>
  <div>
    <div class="ps-4">
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="CART">
      </section-header>
    </div>

    <v-data-table :calculate-widths="true"
                  no-data-text="Aucune donnée"
                  :headers="headers"
                  :items="statSimu"
                  :height="300"
                  :items-per-page="-1"
                  class="white"
                  disable-pagination
                  fixed-header
                  hide-default-footer
                  mobile-breakpoint="100"
                  @click:row="selectStatSimu">
      <template v-slot:[`item.period`]="{ item }">
        {{ formatPeriode(item.period) }}
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
import { Sections } from '@/generated/classes/AppSchema';
import Simulation, { StatSimu } from '@/generated/classes/Simulation';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import { Extended } from '@/framework/base/classes/Schema';
import { DateFormat } from "@/framework/base/helpers/DateFormat";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    SectionHeader
  },
  props: {
    hideTitle: {
      type: Boolean
    },
    extended: {
      type: Boolean
    },
    dialog: {
      type: Boolean
    }
  },
  created() {
    Simulation.stats().then((stats: StatSimu[]) => {
      this.statSimu = stats;
    })
  },
  data() {
    const statSimu: StatSimu[] = [];

    return {
      dialogOpen: false,
      statSimu,
      headers: [
        { title: 'Période', key: 'period', sortable: true },
        { title: 'Nombre de simulations', key: 'nbSimu', sortable: true },
        { title: 'Nombre d\'utilisateurs', key: 'nbUser', sortable: true },
        { title: 'Nouveaux utilisateurs', key: 'nbNewUser', sortable: true }
      ],
      sectionName: Sections.STAT_SIMU
    };
  },
  computed: {
    saveLabel() {
      return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
    },
    errorTxt() {
      return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
    },
    ressource() {
      return RessourceGenSection(GenSection.STAT_SIMU);
    }
  },

  methods: {
    formatPeriode(value: Date): string {
      return DateFormat.getMensuelLabel(value);
    },
    setExtended(extended: Extended): void {
      this.$emit('extended', extended);
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    openDialog() {
      this.dialogOpen = true;
    },
    selectStatSimu(e: Event, value: any) {
      const statSimu = value.item as StatSimu
      this.$emit('updated', statSimu);
    }
  }
})

</script>
